import React from 'react';
import { PopupProps } from './Layout/types';
import Layout from './Layout';

export function Popup(props: PopupProps) {
  return (
    <Layout {...props} isClosable={props.isClosable === undefined || props.isClosable} />
  );
}
